import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Tasks from "@/pages/Tasks";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Notes from "@/pages/Notes";
import CalendarPage from "@/pages/CalendarPage";
import Voice from "@/pages/Voice";
import Files from "@/pages/Files";
import Telegram from "@/pages/Telegram";
import Copilot from "@/pages/Copilot";
import Plugins from "@/pages/Plugins";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary">
        <div className="label-mono text-muted-foreground">Loading Executive OS…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/"
          element={
            <Protected>
              <Layout />
            </Protected>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/:id" element={<ProjectDetail />} />
          <Route path="notes" element={<Notes />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="voice" element={<Voice />} />
          <Route path="files" element={<Files />} />
          <Route path="telegram" element={<Telegram />} />
          <Route path="copilot" element={<Copilot />} />
          <Route path="plugins" element={<Plugins />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
